<template>
    <div>
        <box-reuse :boxlist="boxlist" :top_title="nav_list_name" :overNumber="overNumber" :peak_title="peak_title" @hitTo="toContent" @changeTitleBtn="changetitle" @changeOvernumberBtn="changeoverNumber">
            <!-- 内容页，为true -->
            <div v-html="ContentData" v-if="isshow"></div>
            <!-- 列表页 -->
            <div v-else>
                <div v-if="ListData.length!==0">
                    <div class="box" v-for="item in ListData" :key="item.id" @click="listBtn(item)">
                        <span class="titleBox">{{item.title}}</span>
                        <span class="timeBox">{{item.createdTime}}</span>
                    </div>
                    <div class="paginBox">
                        <!-- 分页 -->
                        <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="queryInfo.pageNo"
                        :page-sizes="[5,10, 15, 20]"
                        :page-size="queryInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                        </el-pagination>
                    </div>
                </div>
                <div v-else>
                    暂无消息
                </div>
            </div>
        </box-reuse>
    </div>
</template>

<script>
import BoxReuse from '../../components/BoxReuse.vue'
export default {
    data() {
        return{
            boxlist:[],
            overNumber:0,
            nav_list_name:'',
            // 列表页数据
            ListData:[],
            // 内容页数据
            ContentData:'',
            // 控制列表页还是内容页显示
            isshow:false,
            // 首次出现的二级标题
            peak_title:'',
            // 查询的参数
            queryInfo:{
                // 当前是第几页
                pageNo:1,
                // 当前显示多少条数据
                pageSize:10
            },
            // 总共多少条数据
            total:400,
            // 点击那个项的id值
            btnId:null
        }
    },
    // created(){
        // this.overNumber=Number(this.$route.query.overNumber)
        // this.getBoxList(this.$route.query.pid,this.$route.query.id)
    // },
    watch:{
        //监听路由地址的改变
        $route:{
            // 立即执行
            immediate:true,
            handler(){
                if(this.$route.query){//需要监听的参数
                    this.overNumber = Number(this.$route.query.overNumber)
                    this.getBoxList(this.$route.query.pid,this.$route.query.id)
                }
            },
            deep:true  //开启深度监听，(监听对象)
        }
    },
    methods:{
        // 发送请求，获取数据
        async getBoxList(pid,id){
            const {data:res}=await this.$http.get('/index/siteInfo')
            if(res.code==200){
                res.data.menus.forEach(item => {
                    if(item.id==pid&&item.sons.length!==0){
                        this.boxlist=item.sons
                        this.nav_list_name=item.name
                        item.sons.forEach(subitem=>{
                            if(subitem.id==id){
                                this.peak_title=subitem.name
                                this.toContent(subitem)
                            }
                        })
                    }
                });
            }
        },
        // 改变title的值
        changetitle(value){
            this.peak_title=value
        },
        // 改变overNumber的值
        changeoverNumber(value){
            this.overNumber=value
        },
        // 集合
        toContent(item){
            // 根据子组件传过来的索引/路径发送请求，获取数据
            if(item.type==1){
                // 列表页
                this.getListData(item.id)
                this.btnId=item.id
                this.isshow=false
            }else if(item.type==2){
                // 外链
                // switch (item.name){
                //     case '捐款公开':this.$router.push({path:'/contribution',query:{donate_name:item.name}})
                //     break;
                //     case '捐物公开':this.$router.push({path:'/benevolence',query:{donate_name:item.name}})
                //     break;
                //     case '资金使用公开':this.$router.push({path:'/fund',query:{donate_name:item.name}})
                //     break;
                //     case '物资发放公开':this.$router.push({path:'/goods',query:{donate_name:item.name}})
                //     break;
                //     default:window.location.href=item.path
                // }
                window.location.href=item.path
            }else if(item.type==3){
                // 内容页
                this.isshow=true
                this.getDetailData(item.id)
            }
        },
        // 获取内容
        async getDetailData(id){
            const {data:res}=await this.$http.get(`/article/list?id=${id}`)
            if(res.code==200){
                if(res.data.menu.content){
                    this.ContentData=res.data.menu.content
                }
            }
        },
        // 获取列表
        async getListData(id){
            const {data:res}=await this.$http.get(`/article/search?pageNo=${this.queryInfo.pageNo}&pageSize=${this.queryInfo.pageSize}&cid=${id}`)
            if(res.code==200){
                this.ListData=res.data.lists
                this.total=res.data.count
            }
        },
        // 点击每一条li触发的函数
        listBtn(item){
            this.$router.push({path:'/maintext',query:{id:item.id}})
        },
        //一页显示多少条变化的函数
        handleSizeChange(newSize){
            this.queryInfo.pageSize=newSize
            this.getListData(this.btnId)
        },
        // 第几页的变化
        handleCurrentChange(newPage){
            this.queryInfo.pageNo=newPage
            this.getListData(this.btnId)
        }
    },
    components:{
        BoxReuse
    }
}
</script>

<style lang="less" scoped>
.box{
    height: 48px;
    line-height: 48px;
    font-size: 16px;
    background-image: url('../../assets/image/nav_bit03.png');
    background-position: left center;
    background-repeat: no-repeat;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    .titleBox{
        margin-left: 20px;
        width: 600px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    }
    .timeBox{
        // width: 120px;
        height: 100%;
        color: #bbbbbb;
    }
}
.paginBox{
    margin-top: 20px;
}
</style>